import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../redux/store';
import { ModalProps } from "../../../../components/common/Interfaces/Modals";
import { assignUserGroupPermissions } from "../../../../redux/actions/userGroups.actions";
import MultiSelectPermissions from "../MultiSelectPermissions";
import ModalShell, { ModalLoading } from "../../../../components/common/Modals/ModalShell";

const AddPermissionsModal: React.FC<ModalProps> = ({open, setOpen}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [selected, setSelected] = useState<any[]>([]);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const {data:userGroup, error, loading} = useSelector((state: RootState) => state.userGroup);

    const handleConfirm = async () => {
        setIsConfirmed(true);
        await dispatch(assignUserGroupPermissions({id:userGroup.id!, permissions: selected}));
    }

    const handleReset = () => {
        setSelected([]);
        setIsConfirmed(false);
    }

    const handleClose = ()=> {
        handleReset();
        setOpen(false);
    }

    const success = !loading && !error && isConfirmed;
    const showForm = !loading && !error && !isConfirmed;

    return (
        <ModalShell
            open={open}
            onClose={handleClose}
            size={showForm ? "md" : "sm"}
            tone={loading ? undefined : error ? "error" : success ? "success" : undefined}
            title={loading ? "Please wait…" : error ? "An error occurred" : success ? "Permissions assigned" : `Add permissions to ${userGroup?.name}`}
            subtitle={showForm ? `Add ${selected.length} ${selected.length===1?`permission`:`permissions`} to ${userGroup?.name}.` : undefined}
            actions={loading ?
                <button className="btn" onClick={handleClose}>Close</button>
                : error ?
                <button className="btn btn-primary" onClick={handleClose}>Close</button>
                : success ?
                <>
                    <button className="btn btn-ghost dlg-actions-start" onClick={handleReset}>Add more permissions</button>
                    <button className="btn btn-primary" onClick={handleClose}>Done</button>
                </>
                :
                <>
                    <button className="btn" onClick={handleClose}>Cancel</button>
                    <button className="btn btn-primary" disabled={selected.length===0} onClick={handleConfirm}>Confirm</button>
                </>
            }
        >
            {loading ?
                <ModalLoading/>
                : error ?
                <p>{error}</p>
                : success ?
                <p>{`${selected.length} ${selected.length===1 ? `permission` : `permissions`} successfully assigned to ${userGroup?.name}.`}</p>
                :
                <div className="dlg-section">
                    <MultiSelectPermissions checked={selected} setChecked={setSelected}/>
                </div>
            }
        </ModalShell>
    )
};

export default AddPermissionsModal;
